module.exports = __webpack_public_path__ + "img/quizzort_cat_inner_bg.3a6f4391.jpg";